import { getProviderInfos } from "@/services/api/sharedEwaybillShippingAddress";
import { useRequest } from "ahooks";
import { Select } from "antd";
import { uniqBy } from "lodash";
import React, { useEffect, useState } from "react";

interface ProviderSelectProps {
  onChange?(companyId?: number): void;
  value?: number;
}

const ProviderSelect: React.FC<ProviderSelectProps> = React.memo(function (props) {
  const { value, onChange } = props;

  const [localValue, setLocalValue] = useState(undefined);

  const { data: providerInfos } = useRequest(async () => {
    let infos = await getProviderInfos();

    infos = uniqBy(infos, (it) => {
      return `${it.companyId}|${it.providerName}`;
    });

    return infos;
  });

  useEffect(() => {
    if (!value) {
      setLocalValue(undefined);
      return;
    }
    const [companyId] = localValue?.split("|") || [];

    if (companyId) {
      const info = providerInfos.find((it) => it.companyId === Number(companyId));

      setLocalValue(`${info.companyId}|${info.providerName}`);
    } else {
      setLocalValue(undefined);
    }
  }, [value]);

  return (
    <Select
      placeholder="全部"
      style={{ width: 156 }}
      allowClear
      showSearch
      optionFilterProp="children"
      value={localValue}
      dropdownMatchSelectWidth={false}
      onChange={(value) => {
        const [companyId] = value?.split("|") || [];

        if (companyId) {
          onChange?.(Number(companyId));
        } else {
          onChange(undefined);
        }

        setLocalValue(value);
      }}
    >
      {providerInfos?.map((it) => {
        return (
          <Select.Option key={it.id} value={`${it.companyId}|${it.providerName}`}>
            {it.providerName}
          </Select.Option>
        );
      })}
    </Select>
  );
});

export default ProviderSelect;
